<template>
    <section>
        <div class="container container--fluid">
            <v-card>
                <v-card-title class="headline">
                    {{$t('logs_list_title')}}
                    <v-spacer></v-spacer>
                    <v-btn
                            small
                            v-if="false"
                            color="primary"
                            class="white--text"
                            @click="dialog = true"
                    >
                        {{$t('send_fax')}}
                        <v-icon right dark>mdi-send</v-icon>
                    </v-btn>
                    <v-btn
                            icon
                            small
                            @click="fetch()"
                    >
                        <v-icon right dark>mdi-reload</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-subtitle>{{$t('logs_list_subtitle')}}</v-card-subtitle>
                <v-divider></v-divider>
                <v-data-table
                        class="text-capitalize"
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        :options.sync="options"
                        :server-items-length="total"
                        :page="options.page"
                        :items-per-page="options.itemsPerPage"
                        :footer-props="footerProps"
                >

                    <template #item.id="{item}">
                        <v-tooltip
                                v-if="item.request_direction === 'in'"
                                top
                                color="success"
                                content-class="caption iransans"
                                transition="slide-y-reverse-transition"
                        >
                            <template #activator="{ on }">
                                <v-icon
                                        v-on="on"
                                        color="success"
                                        small
                                        class="ml-2"
                                >mdi-arrow-down-thick</v-icon>
                            </template>

                            <span>درخواست ورودی</span>
                        </v-tooltip>

                        <v-tooltip
                                v-else
                                top
                                color="error"
                                content-class="caption iransans"
                                transition="slide-y-reverse-transition"
                        >
                            <template #activator="{ on }">
                                <v-icon
                                        v-on="on"
                                        color="error"
                                        small
                                        class="ml-2"
                                >mdi-arrow-up-thick</v-icon>
                            </template>

                            <span>درخواست خروجی</span>
                        </v-tooltip>
                        {{item.id}}
                    </template>
                    <template #item.requested_at_millisecond="{item}">
                        {{ getJalaliDate(item.requested_at_millisecond, 'jYYYY-jMM-jDD HH:mm:ss') }}
                    </template>
                    <template #item.request_method="{item}">
                        <code class="text-uppercase">{{ item.request_method }}</code>
                    </template>
                    <template #item.client_id="{item}">
                        <transition name="fade" mode="out-in">
                            <v-chip
                                    v-if="!item.client_id"
                                    color="error"
                                    x-small
                            > -- </v-chip>

                            <v-skeleton-loader
                                    v-else-if="fetchingUsers"
                                    type="text"
                                    class="mt-2"
                            ></v-skeleton-loader>

                            <span v-else>
                                {{ clients[item.client_id].name }}
                            </span>
                        </transition>
                    </template>
                    <template #item.user_id="{item}">
                        <router-link
                                :to="{name : 'Logs', query : { filters : [{column_name : 'user_id', operand : 'IsEqualTo', value : item.user_id}]}}"
                                color="red"
                                text-color="white"
                                v-bind="attrs"
                                v-on="on"
                        >
                            {{ item.user_fullname}} {{(item.user_mobile)}}
                        </router-link>
                    </template>
                    <template #item.response_code="{item}">
                        <code>{{ item.response_code }}</code>
                    </template>
                    <template #item.url="{item}">
                        <v-chip
                                small
                                color="blue darken-1"
                                dark
                                v-ripple
                                class="clickable"
                                :title="item.url"
                                :style="{ maxWidth: '300px' }"
                        >
                            <span class="text-truncate">{{ item.url }}</span>
                        </v-chip>
                    </template>
                    <template #item.actions="{item}">
                        <v-tooltip
                                top
                                color="primary"
                                content-class="caption iransans px-3"
                                transition="slide-y-reverse-transition"
                        >
                            <template #activator="{ on }">
                                <v-btn
                                        v-on="on"
                                        color="grey"
                                        fab
                                        x-small
                                        text
                                        @click="showLogDetails(item)"
                                        :loading="fetching[item.id] || false"
                                >
                                    <v-icon v-if="logsSeen[item.id]">mdi-eye-check</v-icon>
                                    <v-icon v-else>mdi-eye</v-icon>
                                </v-btn>
                            </template>

                            <span>جزییات لاگ</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>
        </div>

        <v-dialog
                :value="!!logDetails"
                :width="900"
                :retain-focus="false"
                @click:outside="logDetails = null"
        >
            <v-card v-if="logDetails">
                <v-card-title class="grs-card-title px-0 mb-0">
                    <span>جزییات درخواست</span>

                    <v-spacer></v-spacer>

                    <v-btn
                            text
                            small
                            icon
                            @click="logDetails = null"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="px-4 pb-0">
                    <LogDetails
                            :log="logDetails"
                    />
                </v-card-text>
            </v-card>
        </v-dialog>
    </section>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import RequestList from "../services/RequestList";
    import Service from "../services/LogsService";
    import LogDetails from '@/components/LogDetails';
    import CRUDMixin from '../mixins/CRUDMixin'

    export default {
        mixins : [CRUDMixin],

        components : {
            LogDetails
        },

        mounted() {
            this.fetchClients();

        },
        watch: {
            dialog (val) {
                !val && this.close()
            }
        },
        data() {
            return {
                fetching : {},
                logsSeen : {},
                dialog : false,
                loading : false,
                logDetails : null,
                headers : [
                    {
                        text: this.$t('id'),
                        value: 'id',
                    },
                    {
                        text: this.$t('requested_at'),
                        value: 'requested_at_millisecond',
                    },
                    {
                        text: this.$t('request_method'),
                        value: 'request_method',
                    },
                    {
                        text: this.$t('client'),
                        value: 'client_id',
                    },
                    {
                        text: this.$t('user'),
                        value: 'user_id',
                    },
                    {
                        text: this.$t('response_code'),
                        value: 'response_code',
                    },
                    {
                        text: this.$t('duration_millisecond'),
                        value: 'duration_millisecond',
                    },
                    {
                        text: this.$t('url'),
                        value: 'url',
                    },
                    {
                        text: this.$t('action'),
                        value: 'actions',
                    }
                ],
                
                items : [],
            }
        },
        computed: {
            ...mapState({
                clients: state => state.clients.clients
            }),
            ...mapGetters({
                fetchingClients: 'clients/fetching'
            })
        },
        methods: {
            ...mapActions('clients', ['fetchClients']),
            async fetch() {
                this.loading = true;

                let page = this.$route.query.page || 1;
                let count = this.$route.query.count || this.options.itemsPerPage;

                let requestList = new RequestList();

                requestList.setFilters(this.$route.query.filters || []);
                requestList.addOrder('id','desc');
                requestList.setPage(page, count);

                try {

                    let {data} = await Service.list(requestList);
                    this.items = data.value.logs;
                    this.total = data.value.total;
                } finally {
                    this.loading = false;
                }
            },
            async showLogDetails(log) {
                this.logDetails = await this.fetchLogDetails(log.id);
                this.logsSeen[log.id] = true;
            },
            async fetchLogDetails(id) {
                this.fetching[id] = true;

                try {
                    let {
                        data
                    } = await Service.getById(id);

                    return data.value.log;
                } finally {
                    this.fetching[id] = false;
                }
            },

        }
    }
</script>